import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'backoffice-subnavigation',
  templateUrl: './subnavigation.component.html',
  styleUrls: ['./subnavigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SubnavigationComponent {}
